module.exports = __webpack_public_path__ + "img/temper_yellow.ca58c5cb.svg";